import { dew as _VideoQualitySettingsDew } from "../devicecontroller/VideoQualitySettings";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const VideoQualitySettings_1 = __importDefault(_VideoQualitySettingsDew());
  /**
   * [[MeetingFeatures]] contains information on meeting wide configuration which may impact the
   * client.
   */
  class MeetingFeatures {
    constructor(videoMaxResolution = VideoQualitySettings_1.default.VideoResolutionHD, contentMaxResolution = VideoQualitySettings_1.default.VideoResolutionFHD) {
      this.videoMaxResolution = videoMaxResolution;
      this.contentMaxResolution = contentMaxResolution;
    }
    /**
     * Returns a deep copy of meeting features.
     */
    clone() {
      return new MeetingFeatures(this.videoMaxResolution, this.contentMaxResolution);
    }
  }
  exports.default = MeetingFeatures;
  //# sourceMappingURL=MeetingFeatures.js.map
  return exports;
}